import TagManager from 'react-gtm-module'
import {
	CONSTANTS,
	DOMAIN_PROCESS,
	HELPER,
	HISTORY,
	LocalStorageService,
	ROUTE_CONSTANTS,
} from '../../../utils'
import { store } from '../../../store'
import { configActions } from '../../../store/actions'

function SET_COLOR_THEME(theme_color) {
	document.documentElement.style.setProperty('--theme-custom-color', theme_color)
}

function APP_LOCALE() {
	const locale = LocalStorageService._getFromSessionStorage('locale')
	return HELPER.isEmpty(locale) ? locale : ''
}

function SET_APP_LOCALE(locale) {
	LocalStorageService._saveToSessionStorage('locale', locale)
}

function SET_TAG_MANAGER(gtm_id) {
	const tagManagerArgs = {
		gtmId: gtm_id,
		dataLayerName: 'bSecure',
	}
	TagManager.initialize(tagManagerArgs)
}

function APP_BODY_DIRECTION() {
	let bodyEl = document.querySelector('body')
	return bodyEl.getAttribute('dir')
}

function GET_LANG_DIRECTION() {
	let state = store.getState()
	const { locale } = state.Intl
	return locale === CONSTANTS.IS_URDU ? CONSTANTS.LANG_DIRECTION.RTL : CONSTANTS.LANG_DIRECTION.LTR
}

function CHECK_LTR_LANG() {
	return APP_HELPER.GET_LANG_DIRECTION() === CONSTANTS.LANG_DIRECTION.LTR
}

// PRODUCT

function FIND_PRODUCT_BY_ID(product_id) {
	let state = store.getState()
	const { allProducts } = state.inventory
	return allProducts.find((item) => {
		return item.id === product_id
	})
}

function LOAD_APPLICATION() {
	const hostname = window.location.hostname
	if (!hostname.match(process.env.REACT_APP_DOMAIN_URL)) {
		const routeFound = DOMAIN_PROCESS.find((route) => {
			return route.domain === hostname
		})
		if (routeFound) {
			store.dispatch(configActions.CUSTOM_CATALOG_DOMAIN(routeFound.catalog))
		}
	}
}

function MOVE_TO_VIEW_ALL_STORES() {
	const hostname = window.location.hostname
	HISTORY.push(
		hostname.match(process.env.REACT_APP_DOMAIN_URL)
			? ROUTE_CONSTANTS.BASE
			: ROUTE_CONSTANTS.BSECURE_MALL
	)
}

const APP_HELPER = {
	APP_BODY_DIRECTION,
	APP_LOCALE,
	SET_COLOR_THEME,
	SET_APP_LOCALE,
	SET_TAG_MANAGER,
	GET_LANG_DIRECTION,
	CHECK_LTR_LANG,

	FIND_PRODUCT_BY_ID,

	LOAD_APPLICATION,
	MOVE_TO_VIEW_ALL_STORES,
}
export default APP_HELPER
